 <template>
    <div>
        <template  v-for="(v,i) in items" >
            <i :key="i" v-if="v.flag==='hot'" class="iconfont icon-custom-hot" style="color:#FF5722;margin-right:2px" title="热门"></i>
            <i :key="i" v-if="v.flag==='dv'" class="iconfont icon-vimeo2" style="color:#FFC107;margin-right:2px" title="大V"></i>
            <i :key="i" v-if="v.flag==='jian'" class="iconfont icon-jian---" style="color:#FF9800;margin-right:2px" title="编辑推荐"></i>
        </template>
    </div>
</template>
<script>
    export default{
        props:['items']
    }
</script>


// WEBPACK FOOTER //
// src/components/_widget/FrontFlag.vue